var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxt-list__wrapper" }, [
    _c(
      "div",
      { staticClass: "checked_list_box" },
      [
        _c("yxt-scrollbar", { attrs: { "fit-height": true } }, [
          _c("div", { staticClass: "checked_list_tag-wraper" }, [
            _vm.skillData.length > 0
              ? _c(
                  "div",
                  [
                    _vm.source === 1
                      ? _c("div", { staticClass: "font-medium mb12 grey-59" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_biz_gwnl_ability")) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.skillData, function (item, index) {
                      return _c(
                        "yxt-tag",
                        {
                          key: item.id,
                          staticClass: "mr8 polestar_tag",
                          staticStyle: { "margin-bottom": "8px" },
                          attrs: {
                            "disable-transitions": "",
                            size: "small",
                            type: "info",
                            closable: "",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(item, index)
                            },
                          },
                        },
                        [
                          _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                "open-filter": true,
                                content: item.name,
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class: [
                                    "tag_span",
                                    item.includeAll === 1
                                      ? "tag_span_width_tail"
                                      : "",
                                  ],
                                },
                                [_vm._v(_vm._s(item.name) + " ")]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm.taskData.length > 0
              ? _c(
                  "div",
                  [
                    _vm.source === 1
                      ? _c(
                          "div",
                          {
                            staticClass: "font-medium mb12 grey-59 font",
                            class: { mt20: _vm.skillData.length > 0 },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("pc_biz_web_resTasks")) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._l(_vm.taskData, function (item, index) {
                      return _c(
                        "yxt-tag",
                        {
                          key: item.id,
                          staticClass: "mr8 polestar_tag",
                          staticStyle: { "margin-bottom": "8px" },
                          attrs: {
                            "disable-transitions": "",
                            size: "small",
                            type: "info",
                            closable: "",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.handleClose(item, index)
                            },
                          },
                        },
                        [
                          _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                "open-filter": true,
                                content: item.name,
                                placement: "top",
                                "max-width": "240",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class: [
                                    "tag_span",
                                    item.includeAll === 1
                                      ? "tag_span_width_tail"
                                      : "",
                                  ],
                                },
                                [_vm._v(_vm._s(item.name) + " ")]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ]),
      ],
      1
    ),
    _vm.list.length === 0
      ? _c("span", { staticClass: "check-list__placeholder" }, [
          _vm._v(_vm._s(_vm.$t("pc_biz_eval_pleaseSelect"))),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "operation" },
      [
        _c(
          "yxt-button",
          {
            staticClass: "font-size-14 color-primary-6 hover-primary-6",
            attrs: { type: "text", disabled: _vm.list.length === 0 },
            on: { click: _vm.clear },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("biz_udp_clear_all")) + "\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }